import { takeLatest, takeEvery, put, take, call, select } from 'redux-saga/effects'

import { has, isEmpty } from 'lodash'

import { api, routing, auth, users } from '../redux'

//
//  SAGA

export function* saga() {
    yield takeLatest(auth.ACCESS_GRANTED, fetchUserRelatedData)
    yield takeEvery(routing.ROUTE_CHANGED, fetchDataForRoute)
}

function* fetchDataForRoute() {
    const { key, params } = yield select(routing.getCurrentRoute)

    switch (key) {
        case 'parkingLots': {
            const { user_id } = yield select(auth.getToken) // eslint-disable-line camelcase
            has(params, 'id')
                ? yield put(api.get('parkingLots', { id: params.id }))
                : yield put(api.get('parkingLots', { user_id }))

            break
        }

        case 'emailVerification': {
            const { token } = params
            yield put(auth.verifyEmail(token))
            yield take([auth.EMAIL_VERIFICATION_SUCCEEDED, auth.EMAIL_VERIFICATION_FAILED])
            yield call(routing.push, routing.routeFor('dashboard'))
            break
        }

        default: break
    }
}


function* fetchUserRelatedData() {
    const currentUser = yield select(users.getCurrent)
    if (isEmpty(currentUser)) {
        yield take(users.PROFILE_FETCHED)
        yield call(fetchUserRelatedData)
        return
    }

    const forUser = { user_id: currentUser.id }
    yield put(api.get('privileges', forUser))
}
